












import { Component, Vue, Prop } from 'vue-property-decorator';
import { PlanExportExcelButton } from '@/components/plan';
import { Record, Plan } from '@/domains/work';

@Component({
  name: 'PlanUserAction',
  components: {
    PlanExportExcelButton,
  },
})
export default class PlanUserAction extends Vue {
  /** 表单 */
  @Prop()
  private value: Record;

  @Prop()
  private plans: Plan[];

  /** 获取表单 */
  get form(): Record { return this.value; }

  /** 设置表单 */
  set form(value: Record) { this.$emit('input', value); }

  /** bus */
  @Prop()
  private bus: Vue;
}
